<template>
    <div data-testid="workflow-config-table">
        <v-simple-table class="workflow-table" data-testid="workflow__table">
            <template v-slot:default>
                <thead class="tableHeaderBg">
                    <!-- Top Group Header -->
                <tr class="group-header">
                    <th scope="colheader" rowspan="3" class="text-start" style="width: 50px;">
                        <v-checkbox 
                            v-model="allSelected"
                            :indeterminate="indeterminate"
                            hide-details 
                            class="mt-0 pt-0"
                        ></v-checkbox>
                    </th>
                    <th scope="colheader" rowspan="3" class="text-start">
                        <span>S.No</span>
                    </th>
                    <th scope="colheader" rowspan="3" class="text-start" style="min-width: 300px;">
                        <HeaderCell 
                            text="RU Code & Description" 
                            value="ru_code"
                            :sortable="false"
                            :filterable="false"
                            :sort-key="sortKey"
                            :sort-desc="sortDesc"
                            :filter-options="getFilterOptions('ru_code')"
                            :current-filters="filters['ru_code']"
                            @sort="handleSort"
                            @filter="handleFilter"
                        />
                    </th>
                    <th scope="colheader" rowspan="3" style="min-width: 120px;">
                        <HeaderCell 
                            text="All User Set?" 
                            value="allUsersSet"
                            :sortable="false"
                            :filterable="false"
                            :sort-key="sortKey"
                            :sort-desc="sortDesc"
                            :filter-options="getFilterOptions('allUsersSet')"
                            :current-filters="filters['allUsersSet']"
                            @sort="handleSort"
                            @filter="handleFilter"
                        />
                    </th>
                    <th scope="colheader" rowspan="3">
                        <HeaderCell 
                            text="Comparative 1 Materiality Set?" 
                            value="materialityActual"
                            :sortable="false"
                            :filterable="false"
                            :sort-key="sortKey"
                            :sort-desc="sortDesc"
                            :filter-options="getFilterOptions('materialityActual')"
                            :current-filters="filters['materialityActual']"
                            @sort="handleSort"
                            @filter="handleFilter"
                            style="min-width: 120px;"
                        />
                    </th>
                    <th scope="colheader" rowspan="3">
                        <HeaderCell 
                            text="Comparative 2 Materiality Set?" 
                            value="materialityForecast"
                            :sortable="false"
                            :filterable="false"
                            :sort-key="sortKey"
                            :sort-desc="sortDesc"
                            :filter-options="getFilterOptions('materialityForecast')"
                            :current-filters="filters['materialityForecast']"
                            @sort="handleSort"
                            @filter="handleFilter"
                            style="min-width: 120px;"
                        />
                    </th>
                    <th colspan="8" class="text-left border-left" scope="colgroup">
                        <span>Comparative 1 - Workflow</span>
                    </th>
                    <th colspan="8" class="text-left border-left" scope="colgroup">
                        <span>Comparative 2 - Workflow</span>
                    </th>
                    <th colspan="3" scope="colgroup">
                        <span>Others</span>
                    </th>
                </tr>
                <tr>
                    <th colspan="2" class="border-left" scope="colgroup">
                        <span>Local Control</span>
                    </th>

                    <th colspan="2" class="border-left" scope="colgroup">
                        <span>Local Management</span>
                    </th>

                    <th colspan="2" class="border-left" scope="colgroup">
                        <span>Regional Control</span>
                    </th>

                    <th colspan="2" class="border-left" scope="colgroup">
                        <span>Regional Management</span>
                    </th>

                    <th colspan="2" class="border-left" scope="colgroup">
                        <span>Local Control</span>
                    </th>

                    <th colspan="2" class="border-left" scope="colgroup">
                        <span>Local Management</span>
                    </th>

                    <th colspan="2" class="border-left" scope="colgroup">
                        <span>Regional Control</span>
                    </th>

                    <th colspan="2" class="border-left" scope="colgroup">
                        <span>Regional Management</span>
                    </th>

                    <th rowspan="2" scope="colgroup">
                        <HeaderCell 
                            text="Bulk Approve Control" 
                            value="bulkapprove_control"
                            :sortable="false"
                            :filterable="true"
                            :sort-key="sortKey"
                            :sort-desc="sortDesc"
                            :filter-options="getFilterOptions('bulkapprove_control')"
                            :current-filters="filters['bulkapprove_control']"
                            @sort="handleSort"
                            @filter="handleFilter"
                        />
                    </th>
                    <th rowspan="2" scope="colgroup">
                        <HeaderCell 
                            text="Segregation Of Duties" 
                            value="sodEnabled"
                            :sortable="false"
                            :filterable="true"
                            :sort-key="sortKey"
                            :sort-desc="sortDesc"
                            :filter-options="getFilterOptions('sodEnabled')"
                            :current-filters="filters['sodEnabled']"
                            @sort="handleSort"
                            @filter="handleFilter"
                        />
                    </th>
                    <th rowspan="2" scope="colgroup">
                        <HeaderCell 
                            text="Regional Level Auto Submission" 
                            value="autoSubmissionEnabled"
                            :sortable="false"
                            :filterable="true"
                            :sort-key="sortKey"
                            :sort-desc="sortDesc"
                            :filter-options="getFilterOptions('autoSubmissionEnabled')"
                            :current-filters="filters['autoSubmissionEnabled']"
                            @sort="handleSort"
                            @filter="handleFilter"
                        />
                    </th>
                </tr>

                <!-- Sub Header -->
                <tr class="sub-header">
                    <th class="text-center border-left border-top" scope="colgroup">
                        <HeaderCell text="P&L" value="localcontrol_proforma_pl" :sortable="false"
                            :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" :filter-options="getFilterOptions('localcontrol_proforma_pl')" :current-filters="filters['localcontrol_proforma_pl']" @sort="handleSort" @filter="handleFilter" align="center" />
                    </th>
                    <th class="text-center border-top" scope="colgroup">
                        <HeaderCell text="BS" value="localcontrol_proforma_bs" :sortable="false" :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" :filter-options="getFilterOptions('localcontrol_proforma_bs')" :current-filters="filters['localcontrol_proforma_bs']" @sort="handleSort" @filter="handleFilter" align="center" />
                    </th>

                    <th class="text-center border-left border-top" scope="colgroup">
                        <HeaderCell text="P&L" value="localmanagement_proforma_pl" :sortable="false" :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" :filter-options="getFilterOptions('localmanagement_proforma_pl')" :current-filters="filters['localmanagement_proforma_pl']" @sort="handleSort" @filter="handleFilter" align="center" />
                    </th>
                    <th class="text-center border-top" scope="colgroup">
                        <HeaderCell text="BS" value="localmanagement_proforma_bs" :sortable="false" :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" :filter-options="getFilterOptions('localmanagement_proforma_bs')" :current-filters="filters['localmanagement_proforma_bs']" @sort="handleSort" @filter="handleFilter" align="center" />
                    </th>

                    <th class="text-center border-left border-top" scope="colgroup">
                        <HeaderCell text="P&L" value="regionalcontrol_proforma_pl" :sortable="false" :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" :filter-options="getFilterOptions('regionalcontrol_proforma_pl')" :current-filters="filters['regionalcontrol_proforma_pl']" @sort="handleSort" @filter="handleFilter" align="center" />
                    </th>
                    <th class="text-center border-top" scope="colgroup">
                        <HeaderCell text="BS" value="regionalcontrol_proforma_bs" :sortable="false" :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" :filter-options="getFilterOptions('regionalcontrol_proforma_bs')" :current-filters="filters['regionalcontrol_proforma_bs']" @sort="handleSort" @filter="handleFilter" align="center" />
                    </th>

                    <th class="text-center border-left border-top" scope="colgroup">
                        <HeaderCell text="P&L" value="regionalmanagement_proforma_pl" :sortable="false" :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" :filter-options="getFilterOptions('regionalmanagement_proforma_pl')" :current-filters="filters['regionalmanagement_proforma_pl']" @sort="handleSort" @filter="handleFilter" align="center" />
                    </th>
                    <th class="text-center border-top" scope="colgroup">
                        <HeaderCell text="BS" value="regionalmanagement_proforma_bs" :sortable="false" :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" :filter-options="getFilterOptions('regionalmanagement_proforma_bs')" :current-filters="filters['regionalmanagement_proforma_bs']" @sort="handleSort" @filter="handleFilter" align="center" />
                    </th>

                    <!-- Forecast -->
                    <th class="text-center border-left border-top" scope="colgroup">
                        <HeaderCell text="P&L" value="localcontrol_forecast_pl" :sortable="false" :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" :filter-options="getFilterOptions('localcontrol_forecast_pl')" :current-filters="filters['localcontrol_forecast_pl']" @sort="handleSort" @filter="handleFilter" align="center" />
                    </th>
                    <th class="text-center border-top" scope="colgroup">
                        <HeaderCell text="BS" value="localcontrol_forecast_bs" :sortable="false" :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" :filter-options="getFilterOptions('localcontrol_forecast_bs')" :current-filters="filters['localcontrol_forecast_bs']" @sort="handleSort" @filter="handleFilter" align="center" />
                    </th>

                    <th class="text-center border-left border-top" scope="colgroup">
                        <HeaderCell text="P&L" value="localmanagement_forecast_pl" :sortable="false" :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" :filter-options="getFilterOptions('localmanagement_forecast_pl')" :current-filters="filters['localmanagement_forecast_pl']" @sort="handleSort" @filter="handleFilter" align="center" />
                    </th>
                    <th class="text-center border-top" scope="colgroup">
                        <HeaderCell text="BS" value="localmanagement_forecast_bs" :sortable="false" :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" :filter-options="getFilterOptions('localmanagement_forecast_bs')" :current-filters="filters['localmanagement_forecast_bs']" @sort="handleSort" @filter="handleFilter" align="center" />
                    </th>

                    <th class="text-center border-left border-top" scope="colgroup">
                        <HeaderCell text="P&L" value="regionalcontrol_forecast_pl" :sortable="false" :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" :filter-options="getFilterOptions('regionalcontrol_forecast_pl')" :current-filters="filters['regionalcontrol_forecast_pl']" @sort="handleSort" @filter="handleFilter" align="center" />
                    </th>
                    <th class="text-center border-top" scope="colgroup">
                        <HeaderCell text="BS" value="regionalcontrol_forecast_bs" :sortable="false" :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" :filter-options="getFilterOptions('regionalcontrol_forecast_bs')" :current-filters="filters['regionalcontrol_forecast_bs']" @sort="handleSort" @filter="handleFilter" align="center" />
                    </th>

                    <th class="text-center border-left border-top" scope="colgroup">
                        <HeaderCell text="P&L" value="regionalmanagement_forecast_pl" :sortable="false" :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" :filter-options="getFilterOptions('regionalmanagement_forecast_pl')" :current-filters="filters['regionalmanagement_forecast_pl']" @sort="handleSort" @filter="handleFilter" align="center" />
                    </th>
                    <th class="text-center border-top" scope="colgroup">
                        <HeaderCell text="BS" value="regionalmanagement_forecast_bs" :sortable="false" :filterable="true" :sort-key="sortKey" :sort-desc="sortDesc" :filter-options="getFilterOptions('regionalmanagement_forecast_bs')" :current-filters="filters['regionalmanagement_forecast_bs']" @sort="handleSort" @filter="handleFilter" align="center" />
                    </th>
                </tr>
            </thead>
            <tbody>
                <template v-if="loading">
                    <tr v-for="n in 5" :key="n">
                        <td>
                            <v-skeleton-loader type="image" height="20" width="20" class="mt-0 pt-0"></v-skeleton-loader>
                        </td>
                        <td><v-skeleton-loader type="text" width="30"></v-skeleton-loader></td>
                        <td><v-skeleton-loader type="text" width="200"></v-skeleton-loader></td>
                        <td class="text-center border-left"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        <td class="text-center"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        <td class="text-center border-left"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        
                        <!-- workflows proforma -->
                        <td class="text-center border-left"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        <td class="text-center"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        <td class="text-center border-left"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        <td class="text-center"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        <td class="text-center border-left"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        <td class="text-center"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        <td class="text-center border-left"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        <td class="text-center"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>

                        <!-- workflows forecast -->
                        <td class="text-center border-left"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        <td class="text-center"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        <td class="text-center border-left"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        <td class="text-center"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        <td class="text-center border-left"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        <td class="text-center"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        <td class="text-center border-left"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        <td class="text-center"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>

                        <!-- others -->
                        <td class="text-center border-left"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        <td class="text-center border-left"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                        <td class="text-center border-left"><v-skeleton-loader type="text" width="24" height="24" class="mx-auto"></v-skeleton-loader></td>
                    </tr>
                </template>
                <template v-else>
                    <tr v-if="!itemsToDisplay.length">
                        <td colspan="25" class="text-center grey--text">No data available</td>
                    </tr>
                    <tr v-else v-for="(item, index) in itemsToDisplay" :key="item.id" @click="handleRowClick(item)" style="cursor: pointer;">
                        <td @click.stop>
                            <v-checkbox 
                                v-model="selectedItems" 
                                :value="item.id" 
                                hide-details 
                                class="mt-0 pt-0"
                            ></v-checkbox>
                        </td>
                        <td class="text-center">
                            {{ (index + 1) + ((page - 1) * perpage) }}
                        </td>
                        <td>{{ item.ru_code }}</td>
                        <td class="text-center">
                            <StatusIndicator :variant="getVariant(item.allUsersSet)" :custom-label="getLabel(item.allUsersSet)" size="sm" />
                        </td>
                        <td class="text-center">
                            <StatusIndicator :variant="getVariant(item.materialityActual)" :custom-label="getLabel(item.materialityActual)" size="sm" />
                        </td>
                        <td class="text-center">
                            <StatusIndicator :variant="getVariant(item.materialityForecast)" :custom-label="getLabel(item.materialityForecast)" size="sm" />
                        </td>
                        
                        <!-- workflows proforma -->
                        <td class="text-center border-left"><StatusIndicator :variant="getVariant(item.localcontrol_proforma_pl)" :custom-label="getLabel(item.localcontrol_proforma_pl)" size="sm" /></td>
                        <td class="text-center"><StatusIndicator :variant="getVariant(item.localcontrol_proforma_bs)" :custom-label="getLabel(item.localcontrol_proforma_bs)" size="sm" /></td>
                        <td class="text-center border-left"><StatusIndicator :variant="getVariant(item.localmanagement_proforma_pl)" :custom-label="getLabel(item.localmanagement_proforma_pl)" size="sm" /></td>
                        <td class="text-center"><StatusIndicator :variant="getVariant(item.localmanagement_proforma_bs)" :custom-label="getLabel(item.localmanagement_proforma_bs)" size="sm" /></td>
                        <td class="text-center border-left"><StatusIndicator :variant="getVariant(item.regionalcontrol_proforma_pl)" :custom-label="getLabel(item.regionalcontrol_proforma_pl)" size="sm" /></td>
                        <td class="text-center"><StatusIndicator :variant="getVariant(item.regionalcontrol_proforma_bs)" :custom-label="getLabel(item.regionalcontrol_proforma_bs)" size="sm" /></td>
                        <td class="text-center border-left"><StatusIndicator :variant="getVariant(item.regionalmanagement_proforma_pl)" :custom-label="getLabel(item.regionalmanagement_proforma_pl)" size="sm" /></td>
                        <td class="text-center"><StatusIndicator :variant="getVariant(item.regionalmanagement_proforma_bs)" :custom-label="getLabel(item.regionalmanagement_proforma_bs)" size="sm" /></td>

                        <!-- workflows forecast -->
                        <td class="text-center border-left"><StatusIndicator :variant="getVariant(item.localcontrol_forecast_pl)" :custom-label="getLabel(item.localcontrol_forecast_pl)" size="sm" /></td>
                        <td class="text-center"><StatusIndicator :variant="getVariant(item.localcontrol_forecast_bs)" :custom-label="getLabel(item.localcontrol_forecast_bs)" size="sm" /></td>
                        <td class="text-center border-left"><StatusIndicator :variant="getVariant(item.localmanagement_forecast_pl)" :custom-label="getLabel(item.localmanagement_forecast_pl)" size="sm" /></td>
                        <td class="text-center"><StatusIndicator :variant="getVariant(item.localmanagement_forecast_bs)" :custom-label="getLabel(item.localmanagement_forecast_bs)" size="sm" /></td>
                        <td class="text-center border-left"><StatusIndicator :variant="getVariant(item.regionalcontrol_forecast_pl)" :custom-label="getLabel(item.regionalcontrol_forecast_pl)" size="sm" /></td>
                        <td class="text-center"><StatusIndicator :variant="getVariant(item.regionalcontrol_forecast_bs)" :custom-label="getLabel(item.regionalcontrol_forecast_bs)" size="sm" /></td>
                        <td class="text-center border-left"><StatusIndicator :variant="getVariant(item.regionalmanagement_forecast_pl)" :custom-label="getLabel(item.regionalmanagement_forecast_pl)" size="sm" /></td>
                        <td class="text-center"><StatusIndicator :variant="getVariant(item.regionalmanagement_forecast_bs)" :custom-label="getLabel(item.regionalmanagement_forecast_bs)" size="sm" /></td>

                        <!-- others -->
                        <td class="text-center border-left"><StatusIndicator :variant="getVariant(item.bulkapprove_control)" :custom-label="getLabel(item.bulkapprove_control)" size="sm" /></td>
                        <td class="text-center border-left"><StatusIndicator :variant="getVariant(item.sodEnabled)" :custom-label="getLabel(item.sodEnabled)" size="sm" /></td>
                        <td class="text-center border-left"><StatusIndicator :variant="getVariant(item.autoSubmissionEnabled)" :custom-label="getLabel(item.autoSubmissionEnabled)" size="sm" /></td>
                    </tr>
                </template>
            </tbody>
        </template>
    </v-simple-table>

    <Pagination 
        v-if="items.length > 0 || loading"
        :list="[]"
        :itemsperpage="perpage"
        :value="page"
        :length-override="totalPages"
        :hide-on-single-page="false"
        data-testid="workflow-config-table__pagination"
        @input="handlePaginatedData"
        :loading="loading"
    />
    </div>
</template>

<script>
import StatusIndicator from '../../../../../components/StatusIndicator.vue';
import HeaderCell from './HeaderCell.vue';
import Pagination from '../../../../../views/common/Pagination.vue';
import { STATUS_VARIANTS } from '../../../../../components/utils/status-constants';

export default {
    name: 'WorkflowConfig',
    components: {
        StatusIndicator,
        HeaderCell,
        Pagination
    },
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        items: {
            type: Array,
            default: () => []
        },
        page: {
            type: Number,
            default: 1
        },
        meta: {
            type: Object,
            default: () => ({})
        },
        perpage: {
            type: Number,
            default: 25
        },
        resetKey: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            selectedItems: [],
            selectedItemsById: {},
            sortKey: '',
            sortDesc: false,
            filters: {
                allUsersSet: [],
                materialityActual: [],
                materialityForecast: [],
                ru_code: [],
                bulkapprove_control: [],
                sodEnabled: [],
                autoSubmissionEnabled: [],
                localcontrol_proforma_pl: [],
                localcontrol_proforma_bs: [],
                localmanagement_proforma_pl: [],
                localmanagement_proforma_bs: [],
                regionalcontrol_proforma_pl: [],
                regionalcontrol_proforma_bs: [],
                regionalmanagement_proforma_pl: [],
                regionalmanagement_proforma_bs: [],
                localcontrol_forecast_pl: [],
                localcontrol_forecast_bs: [],
                localmanagement_forecast_pl: [],
                localmanagement_forecast_bs: [],
                regionalcontrol_forecast_pl: [],
                regionalcontrol_forecast_bs: [],
                regionalmanagement_forecast_pl: [],
                regionalmanagement_forecast_bs: []
            }
        };
    },
    computed: {
        itemsFormatted() {
            const formatStatus = (val) => {
                if (typeof val === 'string') {
                    const normalized = val.trim().toLowerCase();
                    if (['yes', 'true', '1', 'y'].includes(normalized)) return 'Yes';
                    if (['no', 'false', '0', 'n'].includes(normalized)) return 'No';
                }
                return val ? 'Yes' : 'No';
            }; 
            
            return (this.items || []).map(item => ({
                id: item._id,
                ru_code: item.code + ' - ' + item.name,
                allUsersSet: formatStatus(item.allusersset),
                materialityActual: formatStatus(item.materialityset_actual),
                materialityForecast: formatStatus(item.materialityset_forecast),
                // Proforma
                localcontrol_proforma_pl: formatStatus(item.localcontrol_proforma),
                localcontrol_proforma_bs: formatStatus(item.localcontrol_proforma_bs ?? item.localcontrol_proforma),
                localmanagement_proforma_pl: formatStatus(item.localmanagement_proforma),
                localmanagement_proforma_bs: formatStatus(item.localmanagement_proforma_bs ?? item.localmanagement_proforma),
                regionalcontrol_proforma_pl: formatStatus(item.regionalcontrol_proforma),
                regionalcontrol_proforma_bs: formatStatus(item.regionalcontrol_proforma_bs ?? item.regionalcontrol_proforma),
                regionalmanagement_proforma_pl: formatStatus(item.regionalmanagement_proforma),
                regionalmanagement_proforma_bs: formatStatus(item.regionalmanagement_proforma_bs ?? item.regionalmanagement_proforma),
                // Forecast
                localcontrol_forecast_pl: formatStatus(item.localcontrol_forecast),
                localcontrol_forecast_bs: formatStatus(item.localcontrol_forecast_bs ?? item.localcontrol_forecast),
                localmanagement_forecast_pl: formatStatus(item.localmanagement_forecast),
                localmanagement_forecast_bs: formatStatus(item.localmanagement_forecast_bs ?? item.localmanagement_forecast),
                regionalcontrol_forecast_pl: formatStatus(item.regionalcontrol_forecast),
                regionalcontrol_forecast_bs: formatStatus(item.regionalcontrol_forecast_bs ?? item.regionalcontrol_forecast),
                regionalmanagement_forecast_pl: formatStatus(item.regionalmanagement_forecast),
                regionalmanagement_forecast_bs: formatStatus(item.regionalmanagement_forecast_bs ?? item.regionalmanagement_forecast),
                // Others
                bulkapprove_control: formatStatus(item.bulkapprove_control),
                sodEnabled: formatStatus(item.sodEnabled),
                autoSubmissionEnabled: formatStatus(item.auto_regional_commentary_submission_enabled)
            }));
        },
        filteredAndSortedItems() {
            return this.itemsFormatted;
        },
        itemsToDisplay() {
            return this.filteredAndSortedItems;
        },
        totalPages() {
             const count = this.meta ? (this.meta.totalCount || 0) : 0;
             const safePerPage = Math.max(1, Number(this.perpage) || 1);
             return Math.ceil(count / safePerPage);
        },
        allSelected: {
            get() {
                return this.filteredAndSortedItems.length > 0 && this.filteredAndSortedItems.every(item => this.selectedItems.includes(item.id));
            },
            set(val) {
                const currentPageIds = this.filteredAndSortedItems.map(item => item.id);
                if (val) {
                    // Merge current page IDs with existing cross-page selections (no duplicates)
                    this.selectedItems = [...new Set([...this.selectedItems, ...currentPageIds])];
                } else {
                    // Remove only current page IDs, keep selections from other pages
                    this.selectedItems = this.selectedItems.filter(id => !currentPageIds.includes(id));
                }
            }
        },
        indeterminate() {
            // Indeterminate is scoped to current page only
            const selectedOnCurrentPage = this.filteredAndSortedItems.filter(item => this.selectedItems.includes(item.id)).length;
            return selectedOnCurrentPage > 0 && selectedOnCurrentPage < this.filteredAndSortedItems.length;
        }
    },
    watch: {
        resetKey() {
            // Clear all selections when parent triggers a filter/full refresh
            this.selectedItems = [];
            this.selectedItemsById = {};
        },
        items(newItems) {
            this.cacheSelectedItemDetails(newItems);
        },
        selectedItems(newVal) {
            this.$emit('selection-change', newVal);
            this.syncSelectedItemsById(newVal);
            this.emitSelectionDetailsChange(newVal);
        }
    },
    methods: {
        cacheSelectedItemDetails(items = []) {
            const selectedIdSet = new Set(this.selectedItems);
            if (selectedIdSet.size === 0) return;

            let hasUpdates = false;
            (items || []).forEach(item => {
                if (item?._id && selectedIdSet.has(item._id)) {
                    this.$set(this.selectedItemsById, item._id, item);
                    hasUpdates = true;
                }
            });

            if (hasUpdates) {
                this.emitSelectionDetailsChange(this.selectedItems);
            }
        },

        syncSelectedItemsById(selectedIds) {
            const selectedIdSet = new Set(selectedIds || []);
            Object.keys(this.selectedItemsById).forEach(id => {
                if (!selectedIdSet.has(id)) {
                    this.$delete(this.selectedItemsById, id);
                }
            });

            (this.items || []).forEach(item => {
                if (item?._id && selectedIdSet.has(item._id)) {
                    this.$set(this.selectedItemsById, item._id, item);
                }
            });
        },

        getSelectedItemDetails(selectedIds = this.selectedItems) {
            return (selectedIds || [])
                .map(id => this.selectedItemsById[id])
                .filter(Boolean);
        },

        emitSelectionDetailsChange(selectedIds) {
            this.$emit('selection-details-change', this.getSelectedItemDetails(selectedIds));
        },

        getVariant(value) {
            return value === 'Yes' ? STATUS_VARIANTS.APPROVED : STATUS_VARIANTS.DISABLED;
        },
        getLabel(value) {
            return value;
        },
        handleSort(key) {
            if (this.sortKey === key) {
                this.sortDesc = !this.sortDesc;
            } else {
                this.sortKey = key;
                this.sortDesc = false;
            }
            this.emitFilterChange();
        },
        handleFilter({ key, values }) {
            this.$set(this.filters, key, values);
            this.$emit('update:page', 1);
            this.emitFilterChange(1);
        },
        getFilterOptions(key) {
            const uniqueValues = new Set(this.itemsFormatted.map(item => item[key]).filter(Boolean));
            return Array.from(uniqueValues).sort();
        },
        handleRowClick(item) {
            this.$nova.gotoLink({
                path: `/varianceanalysis/workflow/edit/${item.id}`
            });
        },
        handlePaginatedData(newPage) {
           if (newPage && newPage !== this.page) {
               this.$emit('update:page', newPage);
               this.emitFilterChange(newPage, true);
           }
        },
        emitFilterChange(page = null, isPagination = false) {
            this.$emit('load-data', {
                page: page || this.page,
                filters: this.filters,
                sortKey: this.sortKey,
                sortDesc: this.sortDesc,
                perPage: this.perpage,
                isPagination
            });
        }
    }
}
</script> 